define(function (require) {

    var communicationChannels = {
        AMS: {
            name: 'AMS',
            events: {
                connectionStateChange: 'connectionStateChange',
                onEventNotification:'onEventNotification',
                onExConversationNotification:'onExConversationNotification',
                onBrandProfile: 'onBrandProfile',
                onUserInfo: 'onUserInfo',
                onRingUpdate:'onRingUpdate',
                onRoutingUpdate: 'onRoutingUpdate'
            },
            commands: {},
            requests: {}
        },
        AppEvents:{
            name: 'AppEvent',
            events: {
                beforeVisitorDisposed: 'beforeVisitorDisposed',
                visitorDisposed: 'visitorDisposed',
                sdkNotification: 'sdkNotification',
                sdkNotificationViewed: 'sdkNotificationViewed',
                queryMessagesCompleted: 'queryMessagesCompleted'
            }
        },
        QUEUE_ORB: {
            name: 'QueueOrb',
            events: {
                connectionStateChange: 'connectionStateChange',
                ringCountChange: 'ringCountChange',
                timerChange: 'timerChange',
                autoAccepting: 'autoAccepting',
                acceptSuccess: 'acceptSuccess',
                acceptError: 'acceptError',
                maxChatsChange: 'maxChatsChange',
                visitorChange: 'visitorChange'
            },
            commands: {},
            requests: {}
        },
        SDK: {
            name: 'SDK',
            events: {
                onUserProfileSetCompleted: 'onUserProfileSetCompleted'
            }
        }
    };


    return {
        COMMUNICATION_CHANNELS: communicationChannels
    };

});
